// extracted by mini-css-extract-plugin
export default {"authentication-view":"AuthenticationView_authentication-view__ed7Xl","message":"AuthenticationView_message__QrJ51"};